'use client';

import { useQuery } from '@tanstack/react-query';
import { curatorQueries } from '../../query-factory';

export const useProposalDetail = (campaignProposalId: number | undefined) => {
  return useQuery({
    ...curatorQueries.campaigns.proposalDetail({
      campaignProposalId: campaignProposalId!,
    }),
    enabled: campaignProposalId !== undefined,
  });
};
